module.exports = __webpack_public_path__ + "static/DEV3-8d80c2f87558eb6f8e2aea05e35319d8.png";